import React from 'react';
import { useTranslation } from 'react-i18next';
import usePrevious from '../../../../../Hooks/usePrevious';
import sendNotification from '../../../../../notifications/sendNotification';
import { useUserInfoData } from '../../../../Hooks/useUserInfo';
import useIsWindowVisible from '../../useIsWindowVisible';
import useContentMaps from '../useContentMaps';

export default function useDetectionNotifications(latestDetection?: { id: string, cardId: string, date: number, projectId: string, commandId: string }) {
  const notificationSettings = useUserInfoData().appSettings?.notifications;
  const { isVisible } = useIsWindowVisible();
  const { t } = useTranslation('notifications');
  const { cardTitleMap, commandTitleMap } = useContentMaps(latestDetection?.projectId);

  const previousDetectionId = usePrevious(latestDetection?.id);
  React.useEffect(() => {
    if (latestDetection?.id !== previousDetectionId) {
      if (latestDetection && !isVisible && latestDetection?.cardId && notificationSettings?.notifyOnDetection) {
        sendNotification(
          t('new-detection.title', { title: cardTitleMap.get(latestDetection.cardId) }),
          {
            body: t('new-detection.body', { title: commandTitleMap.get(latestDetection.commandId) }),
            actions: [
              {
                action: 'open',
                title: t('new-detection.open'),
              },
            ],
          },
        );
      }
    }
  }, [latestDetection, previousDetectionId, isVisible, notificationSettings?.notifyOnDetection, t, cardTitleMap, commandTitleMap]);

  const [badgeCount, setBadgeCount] = React.useState(0);

  React.useEffect(() => {
    if (isVisible) {
      setBadgeCount(0);
    }
  }, [isVisible]);

  React.useEffect(() => {
    if (latestDetection && !isVisible) {
      setBadgeCount((prev) => prev + 1);
    }
  }, [latestDetection]);

  React.useEffect(() => {
    (navigator as any).setAppBadge(badgeCount);
  }, [badgeCount]);
}
